import GetWebMembersOperationsRequestModelBase from '../_generated/modelBases/get-web-members-operations-request-model-base';

export default class GetWebMembersOperationsRequestModel extends GetWebMembersOperationsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
